export enum GameFilterCategoryTypesEnum {
    GameType = 'GameType',
    Studio = 'Studio',
}

export enum GameStudioTypeEnum {
    PopularStudios = 'Popular Studios',
    AllStudios = 'All Studios'
}
export interface GameTypeFilter {
    label: string;
    iconPath: string;
    redirectUrl: string;
    redirectUrlMobile?: string;
    amount?: number;
}

export interface GameFilterCategoriesConfig {
    type: GameFilterCategoryTypesEnum;
    closeBtnIconPath: string;
    filterArrowIconPath: string;
    title: string;
    filterTypes: GameTypeFilter[];
}

export interface GameProvider {
    amount: number;
    title: string;
}
